// extracted by mini-css-extract-plugin
export default {"action-item":"action-item_qxCs_"};